module.exports = __webpack_public_path__ + "img/my.0488ca1e.svg";